export default "__VITE_ASSET__c2a14363__"